import { Component, OnInit, ViewChild, Output, EventEmitter, NgZone } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { MixpanelEventLoggingService } from '@app/shared/services/mixpanel-event-logging.service';
import { Title } from '@angular/platform-browser';
import { PackageSubscriptionService } from '../../services/package-subscription.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
declare var window: any; 
import * as _ from 'lodash';
import swal from 'sweetalert2';
import { environment } from '@env/environment';

@Component({
  selector: 'app-checkout-modal',
  templateUrl: './checkout-modal.component.html',
  styleUrls: ['./checkout-modal.component.css'],
  exportAs: 'CheckoutModal'
})
export class CheckoutModalComponent implements OnInit {
  @ViewChild('CheckoutModal') public CheckoutModal: ModalDirective;
  @Output() refreshAPI: EventEmitter<any> = new EventEmitter();
  public reportId: string;
  public researchId: string;
  public entityType: string;
  public reportSubscriptionPackageId: string;
  public tokenDetails: any = {};
  public userRole: string = '';
  buyToken: number = 1;
   totalPrice: number = 250;
tokenPrice: number = 250;
tokenObject: any;
hidePaymentBtn: boolean = false;
stripePublicKey: string;
paymentUsingToken = false;
@BlockUI() blockUI: NgBlockUI;
  constructor(private rolesSharedService: RolesSharedService, private router: Router, private authenticationService: AuthenticationService,
    private mixpanelEventLoggingService: MixpanelEventLoggingService,
    private packageSubscriptionService: PackageSubscriptionService,
    private titleService: Title,
    private ngZone: NgZone
   ) { }

  ngOnInit() {
    this.getUserRole();
    this.stripePublicKey = environment.STRIPE_PUBLIC_KEY;
  }
  showModal(entityType, id) {
    this.entityType = entityType;
    if (this.entityType === 'report') {
      this.reportId = id;
      this.getPaidReportTokenDetails();
    } else if(entityType === 'subscriptionPackage') {
      this.reportSubscriptionPackageId = id;
      this.getPaidPackageTokenDetails();
    } else {
      this.researchId = id;
      this.getPaidResearchTokenDetails();
    }
    this.CheckoutModal.show();
  }

  hideModal() {
    this.CheckoutModal.hide();
  }

  getPaidReportTokenDetails() {
    this.rolesSharedService.getPaidReportDetails(this.reportId).subscribe(
      (rep: any) => {
        this.tokenDetails = rep;
      },
      error => {

      }
    );
  }
  getPaidResearchTokenDetails() {
    this.rolesSharedService.getPaidResearchTokenDetails(this.researchId).subscribe(
      (rep: any) => {
        this.tokenDetails = rep;
      },
      error => {
      }
    );
  }

  getPaidPackageTokenDetails() {
  
    this.packageSubscriptionService.getPaidPackageTokenDetails(this.reportSubscriptionPackageId).subscribe(
      (rep: any) => {
        this.tokenDetails = rep;
       // console.log(this.tokenDetails, 'tokenDetails');
      },
      error => {
      }
    );
  }

  purchaseWithToken() {
    if (this.entityType === 'report') {
      this.rolesSharedService.purchaseReport(this.reportId).subscribe(
        (resp: any) => {
          this.mixpanelEventLoggingService.dispatchEvent("token used", {
            "No.Of Token": this.tokenDetails.reportPriceInToken ? this.tokenDetails.reportPriceInToken : '',
            "Used Token For": this.entityType ? this.entityType : '',
          });
          this.titleService.setTitle('Report Purchased: ' + this.tokenDetails.reportPriceInToken || 'Ecosystm');
          var _hsq = window._hsq = window._hsq || [];
           _hsq.push(["trackEvent", {
            id: this.tokenDetails.reportPriceInToken,
            value : this.tokenDetails.reportPriceInToken
            }]); 
          _hsq.push(['trackPageView'])
          _hsq.push(['refreshPageHandlers']);

          this.refreshAPI.emit();
        }, error => {
        }
      );
    } else if (this.entityType === 'subscriptionPackage') {
  
    //  console.log(this.entityType, 'this.entityType');
      this.packageSubscriptionService.purchasePackage(this.reportSubscriptionPackageId).subscribe(
        (resp: any) => {
          this.mixpanelEventLoggingService.dispatchEvent("token used", {
            "No.Of Token": this.tokenDetails.reportPriceInToken ? this.tokenDetails.reportPriceInToken : '',
            "Used Token For": this.entityType ? this.entityType : '',
          });
          this.titleService.setTitle('Report Purchased: ' + this.tokenDetails.reportPriceInToken || 'Ecosystm');
          var _hsq = window._hsq = window._hsq || [];
           _hsq.push(["trackEvent", {
            id: this.tokenDetails.reportPriceInToken,
            value : this.tokenDetails.reportPriceInToken
            }]); 
          _hsq.push(['trackPageView'])
          _hsq.push(['refreshPageHandlers']);

          this.refreshAPI.emit();
        }, error => {
        }
      );
    }
     else {
      this.rolesSharedService.purchaseResearch(this.researchId).subscribe(
        (resp: any) => {
          this.mixpanelEventLoggingService.dispatchEvent("token used", {
            "No.Of Token": this.tokenDetails.researchPriceInToken ? this.tokenDetails.researchPriceInToken : '',
            "Used Token For": 'Research Module',
          });
          this.titleService.setTitle('Research Purchased: ' + this.tokenDetails.reportPriceInToken || 'Ecosystm');
          var _hsq = window._hsq = window._hsq || [];
           _hsq.push(["trackEvent", {
            id: this.tokenDetails.reportPriceInToken,
            value : this.tokenDetails.reportPriceInToken
            }]); 
          _hsq.push(['trackPageView'])
          _hsq.push(['refreshPageHandlers']); 

          this.refreshAPI.emit();
        }, error => {
        }
      );
    }
  }
  getUserRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }
  purchaseToken() {
    this.router.navigate([`${this.userRole}/purchase-tokens`], {
      queryParams: {
        'entity-type': this.entityType,
        'report-details': this.reportId ? this.reportId : '',
        'research-details': this.researchId ? this.researchId : '',
        'subscription-package-details': this.reportSubscriptionPackageId ? this.reportSubscriptionPackageId: '',
        'required-tokens': this.tokenDetails.tokenRequired || 0
      }
    });
  }

  paymentGateway() {
    this.hidePaymentBtn = true;
    if (this.tokenDetails.packagePrice !== null && this.tokenDetails.packagePrice > 0) {
    //  console.log(this.tokenDetails, 'this.tokenDetails.amount')
      this.blockUI.start("Please wait...");
      var handler = (<any>window).StripeCheckout.configure({
        key: this.stripePublicKey,
        locale: 'auto',
        token: ((token: any) => {
          this.ngZone.run(() => {
            this.paymentCompleteAPI(token);
          });
        }),
        opened: () => {
          this.blockUI.stop();
        },
        closed: () => {
          this.hidePaymentBtn = false;
        }
      });
      handler.open({
        name: 'Payment',
        description: 'Enter details to proceed payment',
        amount: this.tokenDetails.packagePrice * 100
      });
    }
  }

  paymentCompleteAPI(tokenData: any) {
  //  console.log(this.tokenDetails, 'tokenDetails100');
    let purchaseObject: any = {
      stripeToken: tokenData.id || 'payment token',
      reportSubscriptionPackageId: this.reportSubscriptionPackageId,
      paymentTypeDetails : this.paymentUsingToken,
    }
     this.packageSubscriptionService.subPackagePurchase(purchaseObject).subscribe((purchaseTokenStatus: any) => {
   //  console.log('purchaseTokenStatus.statusCode', purchaseTokenStatus);
      if (purchaseTokenStatus.statusCode == 200) {
      
        this.mixpanelEventLoggingService.dispatchEvent("token", {
          "No: of Token": this.buyToken,
          "Payment Mode": "Card"
        });
        this.buyToken = 1;
        swal({
          position: "center",
          type: "success",
          title: "Done",
          showConfirmButton: false,
          timer: 2000
        });
        this.refreshAPI.emit();
      //  this.redirectToDetailsPage();
      } else {
        swal({
          position: "center",
          type: "error",
          title: purchaseTokenStatus.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
    }, (error: any) => {
      this.hidePaymentBtn = false;
    });
  } 
/*   redirectToDetailsPage() {
    const redirectDetails = this.route.snapshot.queryParamMap.get('redirect-details');
    const entityType = this.route.snapshot.queryParamMap.get('entity-type');
    if (entityType === 'report') {
      const reportId = this.route.snapshot.queryParamMap.get('report-details');
      this.hidePaymentBtn = false;
      if (reportId) {
        this.rolesSharedService.setPaymentSate(true);
        this.router.navigate([`${this.userRole}/report-details/${reportId}`]);
      }
    } else if (entityType === 'research') {
      const researchId = this.route.snapshot.queryParamMap.get('research-details');
      this.hidePaymentBtn = false;
      if (researchId) {
        this.rolesSharedService.setPaymentSate(true);
        if(this.userRole === 'tech-vendor') {
          this.router.navigate([`${this.userRole}/market-data/${researchId}`]);
        } else {
          this.router.navigate([`${this.userRole}/research-snapshot/${researchId}`]);
        }
      }
    } else if (redirectDetails) {
      this.location.back();
    } else {
      this.router.navigate([`${this.userRole}/my-profile`]);
    }
  } */
/*   openCheckout() {
    if (_.find(this.cartData, 'editStatus')) {
      swal({
        position: "center",
        type: "info",
        title: "Please complete editing",
        showConfirmButton: false,
        timer: 2000
      });
    }
    else {
      this.choosePayment.openModal();
    }
  }
 */
paymentGatewayUsingToken() {
  this.hidePaymentBtn = true;
  if (this.tokenDetails.packagePrice !== null && this.tokenDetails.packagePrice > 0) {
  //  console.log(this.tokenDetails, 'this.tokenDetails.amount')
  var packageCheckoutAmout = this.tokenDetails.availableTokens * this.tokenPrice;
    if((this.tokenDetails.packagePrice - packageCheckoutAmout) * 100 <= 0) {
      swal({
        position: "center",
        type: "error",
        title: 'You have sufficient token please purchase with token',
        showConfirmButton: false,
        timer: 2000
      });
       return 0; 
    }
    this.blockUI.start("Please wait...");

    var handler = (<any>window).StripeCheckout.configure({
      key: this.stripePublicKey,
      locale: 'auto',
      token: ((token: any) => {
        this.ngZone.run(() => {
          this.paymentCompleteAPI(token);
        });
      }),
      opened: () => {
        this.blockUI.stop();
      },
      closed: () => {
        this.hidePaymentBtn = false;
      }
    });
    
    handler.open({
      name: 'Payment',
      description: 'Enter details to proceed payment',
      amount: (this.tokenDetails.packagePrice - packageCheckoutAmout) * 100
    });
  }
}
/* paymentCompleteAPI(tokenData: any) {
  let purchaseObject: any = {
    stripeToken: tokenData.id || 'payment token',
    packageId: this.tokenDetails.id,

  }
   this.packageSubscriptionService.subPackagePurchase(purchaseObject).subscribe((purchaseTokenStatus: any) => {
    if (purchaseTokenStatus.statusCode == 200) {
      this.mixpanelEventLoggingService.dispatchEvent("token", {
        "No: of Token": this.buyToken,
        "Payment Mode": "Card"
      });
      this.buyToken = 1;
      swal({
        position: "center",
        type: "success",
        title: "Done",
        showConfirmButton: false,
        timer: 2000
      });
    //  this.redirectToDetailsPage();
    } else {
      swal({
        position: "center",
        type: "error",
        title: purchaseTokenStatus.message,
        showConfirmButton: false,
        timer: 2000
      });
    }
  }, (error: any) => {
    this.hidePaymentBtn = false;
  });
}  */

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/checkout-modal/checkout-modal.component.ts